module.exports = __webpack_public_path__ + "static/media/store_address.d5892e03.png";